import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL =
  process.env.REACT_APP_SITE_URL?.replace(/\/$/, "") ||
  "https://this-belongs-to.com";

const DEFAULTS = {
  siteName: "This Belongs To",
  defaultDescription: "This Belongs To — underwear, swimwear and clothing.",
  ogImage: "/og.jpg", 
  twitterHandle: "", 
};

const ensureLeadingSlash = (p) => {
  if (!p) return "/";
  return p.startsWith("/") ? p : `/${p}`;
};

const absoluteUrl = (pathOrUrl) => {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://"))
    return pathOrUrl;
  return `${SITE_URL}${ensureLeadingSlash(pathOrUrl)}`;
};

export default function SEO({
  title,
  description,
  path = "/",
  image, 
  noindex = false,
}) {
  const canonical = `${SITE_URL}${ensureLeadingSlash(path)}`;
  const metaDescription = description || DEFAULTS.defaultDescription;
  const ogImage = image ? absoluteUrl(image) : absoluteUrl(DEFAULTS.ogImage);

  const fullTitle = title
    ? `${title} — ${DEFAULTS.siteName}`
    : DEFAULTS.siteName;

  return (
    <Helmet>
      <title>{fullTitle}</title>

      <link rel="canonical" href={canonical} />
      <meta name="description" content={metaDescription} />
      {noindex && <meta name="robots" content="noindex,follow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={DEFAULTS.siteName} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter (safe to keep even without an account) */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />
      {DEFAULTS.twitterHandle ? (
        <meta name="twitter:site" content={DEFAULTS.twitterHandle} />
      ) : null}
    </Helmet>
  );
}
